export function ContextMenuSeparator() {
  return <div className="-mx-1 my-1 h-px bg-border" />
}
